import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const TableIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M4 8.667C4 7.194 5.124 6 6.51 6h10.98C18.876 6 20 7.194 20 8.667v6.666C20 16.806 18.876 18 17.49 18H6.51C5.124 18 4 16.806 4 15.333V8.667ZM6.51 8c-.347 0-.628.298-.628.667v.666h12.236v-.666c0-.369-.281-.667-.628-.667H6.51Zm11.608 3.333H12.94v1.334h5.177v-1.334Zm0 3.334H12.94V16h4.55c.346 0 .627-.299.627-.667v-.666ZM11.058 16v-1.333H5.883v.666c0 .368.281.667.628.667h4.549Zm-5.176-3.333h5.177v-1.334H5.882v1.334Z", clipRule: "evenodd" }));
});
TableIcon.displayName = "TableIcon";
